// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7ullF","top":"styles_top__2vj3v","left":"styles_left__1wf2Z","description":"styles_description__3YqAW"};